import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';

@Component
export default class AppFileUploader extends Vue {
  @PropSync('filename', { type: String, required: true })
  syncedFilename!: string;
  @PropSync('dataUrl', { type: String, required: true })
  syncedDataUrl!: string;
  @Prop({ required: false, default: 11000000 })
  readonly maxDimension!: number;

  @Prop({ required: true })
  readonly allowedExtensions!: string[];

  beforeUpload(file, ext: string) {
    if (!ext && file.name && file.name.length > 3) {
      const a = (file.name as string).split('.');
      ext = a[a.length - 1];
    }

    if (!this.allowedExtensions.some((extension) => extension.toLowerCase().trim() === ext.toLowerCase().trim())) {
      this.$message.error(
        this.$t('fileExtensionNotAllowedMessage', {
          allowedExtensions: this.allowedExtensions.join(', '),
        }).toString()
      );
      return false;
    }
    return true;
  }

  async handleUpload(data) {
    if (data.file.size > this.maxDimension) {
      this.$message.error(
        this.$t('maxDimensionFileExceed', {
          maxDimension: this.maxDimension / 1000000 - 1,
        }).toString()
      );
      (this.$refs.upload as any).clearFiles();
    } else {
      const formData = new FormData();
      formData.append('file', data.file);
      try {
        this.syncedFilename = data.file.name;
        this.syncedDataUrl = (await this.toBase64(data.file)) as string;
      } catch (err) {
        this.$message.error(this.$t('fileUploadGenericError').toString());
      }
    }
  }

  toBase64(file): Promise<string | ArrayBuffer | null> {
    return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  handleRemove() {
    this.syncedFilename = '';
    this.syncedDataUrl = '';
    (this.$refs.upload as any).clearFiles();
  }

  onError() {
    this.$message.error(this.$t('fileUploadGenericError').toString());
  }
}
